import { Separator as AriaSeparator, type SeparatorProps as AriaSeparatorProps } from "react-aria-components";

import { cn } from "./utils";

export interface SeparatorProps extends Omit<AriaSeparatorProps, "className"> {
  className?: string;
  decorative?: boolean;
}

function Separator({
  className,
  orientation = "horizontal",
  decorative = true,
  ...props
}: SeparatorProps) {
  return (
    <AriaSeparator
      data-slot="separator-root"
      orientation={orientation}
      className={cn(
        "bg-border shrink-0",
        orientation === "horizontal" ? "h-px w-full" : "h-full w-px",
        className,
      )}
      {...props}
    />
  );
}

export { Separator };
